module.exports = "/images/icon_social_yt_color.png?3d9d09f53a576a9ebb92cc4e53cd08c2";